import script from "./FontSizeDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./FontSizeDropdown.vue?vue&type=script&setup=true&lang=js"

import "./FontSizeDropdown.vue?vue&type=style&index=0&id=fbc50f7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbc50f7a"]])

export default __exports__